import { render, staticRenderFns } from "./LoaderDots.vue?vue&type=template&id=c17bc9ea&"
import script from "./LoaderDots.vue?vue&type=script&lang=js&"
export * from "./LoaderDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports